import React from 'react';
import styles from './CTAOverlay.module.css';

/**
 * @component CTAOverlay
 * @description 배경 이미지 위 반투명 어두운 레이어
 * - 텍스트 가독성 확보
 * - z-index: 1 (배경 위, 콘텐츠 아래)
 */
function CTAOverlay() {
  return <div className={styles.overlay} aria-hidden="true" />;
}

export default CTAOverlay;
